
import {GET_ME} from "../actions/user.action";

const initialState = {};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
  case GET_ME:
    return action.payload;
  default:
    return state;
  }
}